<template>
  <div v-if="feeConfiguration">
    <Details :feeConfiguration="feeConfiguration" @feeConfigUpdated="handleFeeConfigUpdate" />
    <FeeRanges :feeConfiguration="feeConfiguration" :url="url" />
  </div>
</template>
<script>
import Details from "./details.vue";
import FeeRanges from "../../generalLayouts/feeRanges/Index.vue";

export default {
  components: {
    Details,
    FeeRanges,
  },
  props: {
    id: {
      required: true,
    },
    feeConfigurationId: {
      required: true,
    },
  },
  data() {
    return {
      feeConfiguration: undefined,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  computed: {
    url() {
      return `api/v1/transactions/countryMappingConfig/${this.feeConfiguration.id}/fees`;
    },
  },
  methods: {
    handleFeeConfigUpdate() {
      this.fetchData();
    },
    async fetchData() {
      await this.$http
        .get(
          `api/v1/transactions/feeConfigurations/${this.feeConfigurationId}/countryMappings/${this.id}`,
        )
        .then((data) => {
          this.feeConfiguration = data;
        });
    },
    async offerUpdated({ message }) {
      this.isEditing = false;
      Notify.success(message);
      this.fetchData();
    },
  },
};
</script>
